'use client';
import { Fragment } from 'react';
import { isArray, isObject } from '@s7/utils';

/**
 * Проверяет, является ли значение react-элементом `(ReactElement)`
 */ var isElement = function(value) {
    if (isArray(value) || value === null) {
        return false;
    }
    if (isObject(value)) {
        return value.type !== Fragment;
    }
    return false;
};

export { isElement };
